<template>
  <ResponsiveModal
    variant="modal"
    size="default"
    showFooter
    :title="t('admin.views.rename.title')"
    :description="t('admin.views.rename.description')"
  >
    <template #content>
      <div class="md:px-6 px-4 md:pb-0 pb-4 md:pt-5 pt-4">
        <TextInput
          size="lg"
          :errorMessage="errorMessage"
          v-model="modelValue"
          @update:model-value="emit('update:name', modelValue)"
        >
          <template #end>
            <Icon v-if="!isEmpty(errorMessage)" name="info-circle" />
          </template>
        </TextInput>
      </div>
    </template>
    <template #footer>
      <div
        class="flex gap-3 justify-end md:flex-row flex-col md:border-t-0 border-t md:pt-8 px-6 md:pb-6 pt-4 pb-4"
      >
        <Button
          :size="!maxSmall ? 'lg' : 'xl'"
          variant="secondary"
          class="grow md:flex hidden"
          :label="t('components.buttons.cancel')"
          @click="emit('cancel')"
        />
        <Button
          :size="!maxSmall ? 'lg' : 'xl'"
          variant="primary"
          class="grow"
          :disabled="!isEmpty(errorMessage)"
          :label="t('components.buttons.save')"
          @click="handleSubmit"
        />
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { isEmpty } from "lodash";
import { useI18n } from "vue-i18n";
import { Icon } from "@/SharedComponents/Icon";
import { Button } from "@/SharedComponents/Buttons";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { TextInput } from "@/SharedComponents/Inputs";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { t } = useI18n();
const { maxSmall } = useBreakpoints();

const emit = defineEmits(["cancel", "submit", "update:name"]);

const props = defineProps({
  errorMessage: {
    type: String,
    required: true,
  },
  initialState: {
    type: String,
    required: false,
  },
});

const modelValue = ref(props.initialState);

watchEffect(() => {
  modelValue.value = props.initialState;
});

const handleSubmit = () => {
  emit("submit");
  modelValue.value = "";
};
</script>
